import { YEAR_END_PROCESS_REQUEST, YEAR_END_PROCESS_FAILURE, SET_PROFIT_LOSS_AMOUNT, YEAR_END_PROCESS_SUCCESS, SAVE_YEAR_END_PROCESS } from '@/redux/types';
import dayjs from '@/utils/dayjs';
import axios from "@/config/axiosConfig";

export const getProfitLossAmount = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: YEAR_END_PROCESS_REQUEST });

      const { auth } = getState();
      const params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        finStartDate: dayjs(auth.finyear?.From_Date)?.format('YYYY-MM-DD'),
        fromDate: dayjs(auth.finyear?.From_Date)?.format('YYYY-MM-DD'),
        toDate: dayjs(auth.finyear?.To_Date)?.format('YYYY-MM-DD'),
        commanMaster: auth.company?.Common_Master
      };

      const queryString = new URLSearchParams(params).toString();
      const fullUrl = `/ledger-report/getProfitLossAmount?${queryString}`;
      
      return axios.get(fullUrl).then((res) => {
        console.log('<<API Response Data: ', res);
        if (res.data) {
          dispatch({ type: SET_PROFIT_LOSS_AMOUNT, payload: res.data });
        }
        return res.data;
      }).catch((error) => {
        console.error("Error fetching Profit Loss Amount:", error);
        dispatch({ type: YEAR_END_PROCESS_FAILURE, error: error.message });
        return error;
      });
    } catch (error) {
      console.error("Error fetching Profit Loss Amount:", error);
      dispatch({ type: YEAR_END_PROCESS_FAILURE, error: error.message });
    }
  };
};

export const getYearEndProcess = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: YEAR_END_PROCESS_REQUEST });
      const { auth } = getState();
      const params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        finStartDate: dayjs(auth.finyear?.From_Date)?.format('YYYY-MM-DD'),
        fromDate: dayjs(auth.finyear?.From_Date)?.format('YYYY-MM-DD'),
        toDate: dayjs(auth.finyear?.To_Date)?.format('YYYY-MM-DD'),
        commanMaster: auth.company?.Common_Master
      };
      
      return axios.get('/year-end-process/get-data', { params }).then((res) => {
        console.log('<<Res--', res);
        dispatch({ type: SAVE_YEAR_END_PROCESS, payload: res.data });
        return res.data;
      }).catch((error) => {
        console.error("Error get year-end-process:", error);
        dispatch({ type: YEAR_END_PROCESS_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error("Error get year-end-process:", error);
      dispatch({ type: YEAR_END_PROCESS_FAILURE, error: error.message });
      throw error;
    }
  }
}
export const saveYearEndProcess = (data, type) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: YEAR_END_PROCESS_REQUEST });
      const { auth } = getState();
      const params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        userId: auth.user?.id,
      };
      
      return axios.post('/year-end-process/save', {
        data,
        type,
        date: dayjs(auth.finyear?.To_Date)?.format('YYYY-MM-DD')
      }, { params }).then(async (res) => {
        if (res.data) {
          await dispatch(getYearEndProcess());
        }
        return res.data;
      }).catch((error) => {
        console.error("Error save year-end-process:", error);
        dispatch({ type: YEAR_END_PROCESS_FAILURE, error: error.message });
        return error;
      });
    } catch (error) {
      console.error("Error save year-end-process:", error);
      dispatch({ type: YEAR_END_PROCESS_FAILURE, error: error.message });
    }
  }
}

export const deleteYearEndProcess = (ids) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: YEAR_END_PROCESS_REQUEST });
      
      return axios.delete('/journal-voucher/bulk-delete', { params: { ids } }).then(async (res) => {
        if (res.data) {
          await dispatch(getYearEndProcess());
        }
        return res.data;
      }).catch((error) => {
        console.error("Error save year-end-process:", error);
        dispatch({ type: YEAR_END_PROCESS_FAILURE, error: error.message });
        return error;
      });
    } catch (error) {
      console.error("Error save year-end-process:", error);
      dispatch({ type: YEAR_END_PROCESS_FAILURE, error: error.message });
    }
  }
}

export const isYearEndProcessAdd = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: YEAR_END_PROCESS_REQUEST });
      const { auth } = getState();
      const params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };
      
      return axios.get('/year-end-process/get-jv-status', { params }).then((res) => {
        return !!res.data?.exist;
      }).catch((error) => {
        console.error("Error get year-end-process:", error);
        throw error;
      });
    } catch (error) {
      console.error("Error get year-end-process:", error);
      throw error;
    }
  }
}